import React from 'react';

interface TicketShapeSVGProps {
    id: string;
    width: number;
    height: number;
    notchPosition: number;
    notchRadius?: number;
    cornerRadius?: number;
}

const TicketShapeSVG: React.FC<TicketShapeSVGProps> = ({
    id,
    width,
    height,
    notchPosition,
    notchRadius,
    cornerRadius,
}) => {
    // Calculate responsive notch radius as percentage of width (4.8% looks good for most cases)
    const responsiveNotchRadius = notchRadius || Math.max(width * 0.048, 12);
    // Calculate responsive corner radius as percentage of width
    const responsiveCornerRadius = cornerRadius || Math.max(width * 0.024, 6);

    // Calculate aspect ratio to compensate for stretching and keep notches circular
    const aspectRatio = width / height;
    const compensatedNotchRadius = responsiveNotchRadius / (aspectRatio * 0.8);

    return (
        <svg
            width="100%"
            height="100%"
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="none"
            style={{ overflow: 'visible' }}
        >
            <defs>
                <filter id={`shadow-${id}`} x="-50%" y="-50%" width="200%" height="200%">
                    <feDropShadow
                        dx="0"
                        dy="2"
                        stdDeviation="8"
                        floodColor="#000000"
                        floodOpacity="0.2"
                    />
                </filter>
            </defs>

            <path
                d={`
                    M${responsiveCornerRadius},0 
                    H${width - responsiveCornerRadius} 
                    Q${width},0 ${width},${responsiveCornerRadius}
                    V${notchPosition - compensatedNotchRadius} 
                    C${width - responsiveNotchRadius},${notchPosition - compensatedNotchRadius} ${width - responsiveNotchRadius},${notchPosition + compensatedNotchRadius} ${width},${notchPosition + compensatedNotchRadius} 
                    V${height - responsiveCornerRadius} 
                    Q${width},${height} ${width - responsiveCornerRadius},${height}
                    H${responsiveCornerRadius} 
                    Q0,${height} 0,${height - responsiveCornerRadius}
                    V${notchPosition + compensatedNotchRadius} 
                    C${responsiveNotchRadius},${notchPosition + compensatedNotchRadius} ${responsiveNotchRadius},${notchPosition - compensatedNotchRadius} 0,${notchPosition - compensatedNotchRadius} 
                    V${responsiveCornerRadius}
                    Q0,0 ${responsiveCornerRadius},0
                `}
                fill="white"
                filter={`url(#shadow-${id})`}
            />
        </svg>
    );
};

export default TicketShapeSVG;
